import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { AlertItem, isAlertGroupRow } from "../../../../../models/Alerts/Alert";
import { alertsStore } from "../../../stores/alerts/AlertsStore";
import { AlertListModel } from "../../../stores/alerts/AlertListModel";
import {
  AlertsSurface,
  trackAlertsAction,
} from "../../../../../analytics/alertsTracking";

export const alertDetailPath = (alertId: number) => `/alerts/${alertId}`;

/** Inbox showing one alert group's alerts. */
export const alertGroupPath = (groupId: number) => `/alerts?group=${groupId}`;

/**
 * Row tap: mark read, then deep link to the record. Unknown ref types (or a
 * route the app can't build) fall back to the alert detail page. A group row
 * of a grouped list opens the group's alerts instead.
 */
export const useOpenAlert = (surface: AlertsSurface, list?: AlertListModel) => {
  const navigate = useNavigate();

  return useCallback(
    (alert: AlertItem, onNavigate?: () => void) => {
      if (isAlertGroupRow(alert) && alert.group && !list?.groupId) {
        trackAlertsAction("row_open", surface, {
          alert,
          view: list?.view,
          section: list?.section,
          target: "group",
        });
        onNavigate?.();
        navigate(alertGroupPath(alert.group.id));
        return;
      }
      if (alert.me.read_at == null) {
        alertsStore.markRead([alert.id]).catch((error: any) => {
          list?.setActionFeedback(
            error?.message || "Couldn't mark the alert as read.",
          );
        });
      }
      const webRoute = alertsStore.webRoute(alert);
      const route = webRoute ?? alertDetailPath(alert.id);
      trackAlertsAction("row_open", surface, {
        alert,
        view: list?.view,
        section: list?.section,
        target: webRoute ? "record" : "detail",
      });
      onNavigate?.();
      try {
        navigate(route);
      } catch (error) {
        console.error(error);
        navigate(alertDetailPath(alert.id));
      }
    },
    [list, navigate, surface],
  );
};
